const elms = {
	aboutMenuWrap: document.getElementById('aboutMenuWrap'),
	aboutMenu: document.getElementById('aboutMenu'),
	anchors: document.querySelectorAll('.anchor'),
	menuItems: document.querySelectorAll('#aboutMenu a'),
};

const PAD = 107;
const MINUS = 194;

const aboutMenuSticky = () => {
	if (!elms.aboutMenuWrap || !elms.aboutMenu) {
		return false;
	}

	const start = elms.aboutMenuWrap.getBoundingClientRect().top + document.scrollingElement.scrollTop - PAD;
	const end = elms.aboutMenuWrap.getBoundingClientRect().bottom + document.scrollingElement.scrollTop - elms.aboutMenu.offsetHeight + MINUS - PAD;

	if (document.scrollingElement.scrollTop >= start && document.scrollingElement.scrollTop < end) {
		if (!elms.aboutMenu.classList.contains('fix')) {
			elms.aboutMenu.classList.add('fix');
		}
		if (elms.aboutMenu.classList.contains('bottom')) {
			elms.aboutMenu.classList.remove('bottom');
		}

		let anchorPos = 0;
		elms.anchors.forEach((el, i) => {
			const trigger = el.getBoundingClientRect().top + document.scrollingElement.scrollTop - PAD;
			if (document.scrollingElement.scrollTop >= trigger) {
				anchorPos = i;
			}
		});

		if (!elms.menuItems[anchorPos].classList.contains('current')) {
			elms.menuItems.forEach((el, i) => {
				if(i !== anchorPos) {
					el.classList.remove('current');
				}
			});
			elms.menuItems[anchorPos].classList.add('current');
		}

	} else if (document.scrollingElement.scrollTop >= end) {
		if (elms.aboutMenu.classList.contains('fix')) {
			elms.aboutMenu.classList.remove('fix');
		}
		if (!elms.aboutMenu.classList.contains('bottom')) {
			elms.aboutMenu.classList.add('bottom');
		}
	} else {
		if (elms.aboutMenu.classList.contains('fix')) {
			elms.aboutMenu.classList.remove('fix');
		}
		if (elms.aboutMenu.classList.contains('bottom')) {
			elms.aboutMenu.classList.remove('bottom');
		}
	}
};

window.addEventListener('scroll', aboutMenuSticky);
